import { Box, Card } from '@mui/material'
import { styled } from '@mui/system'

interface ScrapbookItemProps {
    rotation: number;
    top: string;
    left: string;
  }

export const ScrapbookContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: '20px',
    position: 'relative',
    padding: '40px',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      gap: '10px',
      padding: '15px',
    },
}))

export const ScrapbookItem = styled(Card, {
    shouldForwardProp: (prop) => prop !== 'rotation' && prop !== 'top' && prop !== 'left',
})<ScrapbookItemProps>(({ rotation, top, left, theme }) => ({
    position: 'relative',
    transform: `rotate(${rotation}deg)`,
    width: '180px',
    padding: '10px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
    transition: 'transform 0.2s',
    '&:hover': {
      transform: `rotate(${rotation + 2}deg) scale(1.05)`,
      boxShadow: '0 6px 12px rgba(0, 0, 0, 0.7)',
    },
    [theme.breakpoints.down('md')]: {
      width: '120px',
      padding: '5px',
      '& .MuiCardMedia-root': {
        height: '120px',
      },
    },
    [theme.breakpoints.down('sm')]: {
      width: '100px',
      padding: '4px',
      '& .MuiCardMedia-root': {
        height: '100px',
      },
      '& .MuiTypography-root': {
        fontSize: '0.7rem',
      },
    },
  }));
